import { Box, Grid } from "@mui/material"
import { useApi } from "auth/useApi3"
import ContinueDialog from "components/Dialogs/ContinueDialog"
import SuccessDialog from "components/Dialogs/SuccessDialog"
import { RouterPrompt } from "components/RouterPrompt"
import { Formik } from "formik"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { statusAlertText } from "pages/external/pages/workorder/components/helpers"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { statusButtonText } from "./EmailBox/helpers"
import WorkOrderEmailBox from "./EmailBox/WorkOrderEmailBox/WorkOrderEmailBox"

import WorkOrderButtons from "./WorkOrderButtons"
import WorkOrderCard from "./workOrderCard/WorkOrderCard"
import WorkOrderTitle from "./WorkOrderTitle"
import { workOrderValidationSchema } from "./workOrderValidationSchema"
import { useTranslation } from "react-i18next"

const AlertDialog = (props) => {
  const { setShowContinueModal, setShowSuccessModal, onSubmit, values, result } = props
  const { t } = useTranslation()

  return (
    <ContinueDialog
      result={result}
      setShowContinueModal={setShowContinueModal}
      setShowSuccessModal={setShowSuccessModal}
      cancelBtnText={t("global.cancel", "Cancel")}
      continueBtnText={statusButtonText(values.status, t)}
      message={
        values.issueReports.find((report) => report.added === true) === undefined
          ? t(
              "issuereports.you_have_not_choosen_issuereport",
              "NOTE: You have not selected a issue report. "
            ) + statusAlertText(values.status, t)
          : statusAlertText(values.status, t)
      }
      onAddSubmit={() => onSubmit(values)}
    />
  )
}

const WorkOrderForm = (props) => {
  const {
    handleModals,
    setShowSuccessModal,
    addResult,
    updateResult,
    onUpdate,
    setVehicle,
    vehicleId,
    initialValues,
    match,
    vehiclesApi,
    vehiclesResult,
    setShowContinueModal,
    showContinueModal,
    showSuccessModal,
    showUpdateModal,
    setShowUpdateModal,
    onAddSubmit,
    workorderResult,
    vehicleIdFromDash,
    sendBooking
  } = props
  const routerHistory = useHistory()
  const [showDeleteModel, setShowDeleteModal] = useState(false)
  const [deleteResult, deleteWorkOrderApi] = useApi()
  const [showAlertDialog, setShowAlertDialog] = useState(false)
  const { t } = useTranslation()

  // handle submit formik form & show continue modal
  const handleSubmit = () => {
    setShowContinueModal(true)
  }

  // delete workorder
  const onDelete = () => {
    deleteWorkOrderApi.del(apiEndpoints.issuereportsadmin.deleteworkorder.replace("{id}", match.params.id))
    setShowDeleteModal(false)
  }

  // update grid on delete api call success finish
  useEffect(() => {
    if (deleteResult.status === 2) {
      routerHistory.push(allRoutes.IssuereportsWorkorders())
    }
  }, [deleteResult.status, routerHistory, vehiclesApi])

  return (
    <div>
      <Box mb={5}>
        <WorkOrderTitle initialValues={initialValues} />
      </Box>
      <Formik
        initialValues={initialValues}
        validationSchema={workOrderValidationSchema(t)}
        onSubmit={handleSubmit}
        enableReinitialize={true}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isSubmitting,
          handleSubmit,
          setFieldValue
        }) => (
          <Box>
            <form id="WorkOrderForm" onSubmit={handleSubmit} noValidate>
              {!showAlertDialog && <RouterPrompt />}

              <Box marginY={3} mt={0}>
                <Grid container spacing={4} justifyContent="flex-start">
                  <Grid item xs={12} lg={8}>
                    <WorkOrderCard
                      t={t}
                      vehicleId={vehicleId}
                      status={workorderResult?.status ? workorderResult?.status : 1}
                      vehicleIdFromDash={vehicleIdFromDash}
                      initialValues={initialValues}
                      vehiclesResult={vehiclesResult}
                      values={values}
                      setFieldValue={setFieldValue}
                      setVehicle={setVehicle}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                    />
                  </Grid>

                  <WorkOrderEmailBox
                    status={workorderResult?.status ? workorderResult?.status : 1}
                    values={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    submit={setShowAlertDialog}
                  />
                </Grid>

                <WorkOrderButtons
                  t={t}
                  buttonFeedbackResult={addResult}
                  values={values}
                  buttonFeedbackResultUpdate={updateResult}
                  initialValues={initialValues}
                  buttonFeedbackResultDelete={deleteResult}
                  setShowDeleteModal={setShowDeleteModal}
                  setShowUpdateModal={setShowUpdateModal}
                />
              </Box>
              {showAlertDialog && (
                <AlertDialog
                  onSubmit={sendBooking}
                  result={values.status > 1 ? updateResult : addResult}
                  setShowContinueModal={setShowAlertDialog}
                  values={values}
                />
              )}

              {showContinueModal && (
                <ContinueDialog
                  result={addResult}
                  setShowContinueModal={setShowContinueModal}
                  setShowSuccessModal={setShowSuccessModal}
                  message={t(
                    "issuereports.do_you_want_to_save_workorder",
                    "Do you want to save the workorder?"
                  )}
                  cancelBtnText={t("global.cancel", "Cancel")}
                  continueBtnText={t("global.save", "Save")}
                  onAddSubmit={handleModals}
                />
              )}

              {showDeleteModel && (
                <ContinueDialog
                  result={deleteResult}
                  setShowContinueModal={setShowDeleteModal}
                  onAddSubmit={onDelete}
                  cancelBtnText={t("global.cancel", "Cancel")}
                  continueBtnText={t("issuereports.delete_workorder", "Delete work order")}
                  message={t(
                    "issuereports.do_you_want_to_delete_workorder",
                    "Do you want to delete the workorder?"
                  )}
                />
              )}

              {showUpdateModal && (
                <ContinueDialog
                  result={updateResult}
                  onAddSubmit={onUpdate}
                  values={values}
                  setShowContinueModal={setShowUpdateModal}
                  cancelBtnText={t("global.cancel", "Cancel")}
                  continueBtnText={t("global.save", "Save")}
                  message={t(
                    "issuereports.do_you_want_to_update_workorder",
                    "Do you want to update the work order?"
                  )}
                />
              )}

              {showSuccessModal && (
                <SuccessDialog
                  values={values}
                  onAddSubmit={onAddSubmit}
                  title={t("issuereports.your_workorder_has_been_saved", "Your work order has been saved")}
                />
              )}
            </form>
          </Box>
        )}
      </Formik>
    </div>
  )
}

export default WorkOrderForm
